<template>
    <table class="table table-responsive">
        <thead>
        <tr>
            <th v-for="key in columns"
                style="cursor:pointer"
                @click="sortBy(key.value)"
                :class="{ active: sortKey == key.value }">
                {{ key.label | capitalize }}
              <span v-if="!isObj(key.value)" class="arrow" :class="sortOrders[key.value] > 0 ? 'asc' : 'dsc'">
              </span>
            </th>
            <th v-if="actionCol" class="action">{{ getTranslation('lbl_grid_col_action') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(entry, entryIndex) in filteredData">
            <td v-for="(key, index) in columns">
                <span v-if="(!editable || !editable[index]) && copyButtons.indexOf(key.value) < 0">
                    {{entry[key.value]}}
                </span>
                <button v-if="entry.locked && key.value === 'locked'" @click.prevent="unlock(entry)"  class="btn btn-default"
                         :title="getTranslation('lbl_unlock')"><span
                        class="glyphicon glyphicon-lock" aria-hidden="true"></span></button>
                <button v-if="(!editable || !editable[index]) && 
                            copyButtons.indexOf(key.value) >= 0 && entry[key.value]"
                        class="btn btn-default" v-clipboard:copy="entry[key.value]" @click.prevent="">
                    {{ getTranslation('lbl_copy') }}
                </button>
                <input ref="'entry'+index" @keyup.enter="update(entry);moveNext($event)"
                       @keyup.esc="cancel(entry)"
                       class="form-control" type="text"
                       v-if="editable && editable[index]"
                       v-model="entry[key.value]">
            </td>
            <td v-if="actionCol" style="white-space: nowrap;">
                <router-link  v-if="viewBtn" :to="viewLink + '/' + entry[idField]" tag="button" class="btn btn-default"
                 :title="getTranslation('lbl_view')">
                    <span class="fa fa-eye" aria-hidden="true"></span></router-link>
                <router-link  v-if="editBtn && !entry.noEdit" :to="actionLink + '/' + entry[idField]" class="btn btn-default"
                              :title="getTranslation('lbl_edit')">
                    <span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></router-link>
                <button  v-if="saveBtn" @click.prevent="update(entry)"  class="btn btn-default"
                  :title="getTranslation('lbl_check')"><span
                        class="glyphicon glyphicon-ok" aria-hidden="true"></span></button>
                <button  v-if="cancelBtn" @click.prevent="cancel(entry)"
                         class="btn btn-default"
                :title="getTranslation('lbl_refresh')"><span
                        class="glyphicon glyphicon-refresh" aria-hidden="true"></span></button>
                <button  v-if="deleteBtn && !entry.noDelete" @click.prevent="deleteEntry(entry)" class="btn btn-danger"><span
                         :title="getTranslation('lbl_delete')" class="glyphicon glyphicon-trash"
                        aria-hidden="true"></span></button>
                <router-link v-if="history && !entry.noHistory" :to="history + '/' + entry[idField]" tag="button"
                             class="btn btn-primary" :title="getTranslation('lbl_history')"><i
                        class="fa fa-history" aria-hidden="true"></i></router-link>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>

    import { translationMixin } from '../../Banet/mixins/translationMixin.js';

    export default {
        mixins: [ translationMixin ],
        props: {
            data: Array,
            entryIdField: String,
            columns: Array,
            editable: Array,
            filterKey: String,
            actionCol: Boolean,
            viewBtn: Boolean,
            editBtn: Boolean,
            viewLink: String,
            saveBtn: Boolean,
            cancelBtn: Boolean,
            deleteBtn: Boolean,
            actionLink: String,
            actionUpdate: String,
            actionCreate: String,
            actionDelete: String,
            history: String,
            unlockBtn: Boolean,
        },
        data: function () {
            var sortOrders = {};
            var that = this;
            this.columns.forEach(function (key) {
                if(!that.isObj(key.value)) {
                    sortOrders[key.value] = 1;
                }
            });

            var filteredData = [];

            return {
                sortKey: '',
                sortOrders: sortOrders,
                initialData: Array,
                filteredData: filteredData,
                copyButtons: ['twilioAccountSid', 'twilioAccountToken', 'clientApiToken']
            }
        },
        watch: {
            columns: function() {
                var that = this;
                this.columns.forEach(function (key) {
                    if(!that.isObj(key.value)) {
                        that.sortOrders[key.value] = 1;
                    }
                });
                this.filteredData = this.filterData();
            },
            data: function() {
                this.filteredData = this.filterData();
            },
            filterKey: function() {
                this.filteredData = this.filterData();
            }
        },
        computed: {
            idField: function(){
                if(!this.entryIdField){
                    return '_id';
                }
                return this.entryIdField;
            }
        },
        filters: {
            capitalize: function (str) {
                if(str === Object(str)){
                    str = str.custom.label;
                }
                return str.charAt(0).toUpperCase() + str.slice(1);
            }
        },
        methods: {
            sortBy: function (key) {
                if(this.isObj(key)) { return false; }
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;

                this.filteredData = this.filterData();
            },
            filterData: function () {
                var sortKey = this.sortKey;
                var filterKey = this.filterKey && this.filterKey.toLowerCase();
                var order = this.sortOrders[sortKey] || 1;
                var data = this.data;
                if (filterKey) {
                    data = data.filter(function (row) {
                        var visibleRow = {};
                        for (var i in row) {
                            var foundCol = false;
                            for (var j in this.columns)
                                if (this.columns[j].value == i && this.columns[j].value.indexOf('Token') < 0)
                                    foundCol = true;
                            if (foundCol)
                                visibleRow[i] = row[i];
                        }
                        return Object.keys(visibleRow).some(function (key) {
                            return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                        })
                    }.bind(this));
                }
                if (sortKey) {
                    data = data.slice().sort(function (a, b) {
                        a = a[sortKey];
                        b = b[sortKey];
                        return (a === b ? 0 : a > b ? 1 : -1) * order
                    })
                }
                this.initialData = data;
                return data;
            },
            isObj: function(str){
                if(!str) {
                    return false;
                }
                return str === Object(str);

            },
            isArr: function(str) {
                return (Array.isArray(str)) ? true : false;
            },
            unlock: function(entry){
                this.$emit('unlock', entry);
            },
            update: function(data){
                this.$emit('update', data);
            },
            deleteEntry: function(data){
                this.$emit('delete', data);
            },
            cancel: function(data){
                this.$emit('cancel', data);
            },
            moveNext: function(el){
//                console.log(el.srcElement);
//                this.$refs.field.focus();
            }
        }
    }
</script>


<style>
    .action{
        width: 5px;
    }
    /*table {*/
        /*border: 2px solid #333333;*/
        /*border-radius: 3px;*/
        /*background-color: #fff;*/
    /*}*/

    /*th {*/
        /*background-color: #333333;*/
        /*color: rgba(255,255,255,0.66);*/
        /*cursor: pointer;*/
        /*-webkit-user-select: none;*/
        /*-moz-user-select: none;*/
        /*-ms-user-select: none;*/
        /*user-select: none;*/
    /*}*/

    /*td {*/
        /*background-color: #f9f9f9;*/
    /*}*/

    /*th, td {*/
        /*min-width: 120px;*/
        /*padding: 10px 20px;*/
    /*}*/

    /*th.active {*/
        /*color: #fff;*/
    /*}*/

    th.active .arrow {
        opacity: 1;
    }

    .arrow {
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        margin-left: 5px;
        opacity: 0.66;
    }

    .arrow.asc {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 4px solid #2c3e50;
    }

    .arrow.dsc {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid #2c3e50;
    }
</style>


// WEBPACK FOOTER //
// BanetTablegrid.vue?63db7463